<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/user-management.vue'
import axios from 'axios'
import { hasErrors } from '@utils/form'
import { httpServices } from '@utils/http-services'

export default {
  page: {
    title: 'User Profile',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      showUser: true,
      hasErrors,
      user: null,
      features: [],
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    }
  },
  mounted() {
    axios
      .get(
        process.env.VUE_APP_KONSUL_API_URL +
          '/users/user/' +
          this.$route.params.userId,
        {
          headers: {
            Authorization: 'Bearer ' + this.$auth.user.access_token,
          },
        }
      )
      .then((res) => {
        this.user = res.data
        httpServices
          .getOrganization(this.user.permissions.organization)
          .then((res) => {
            this.org = res
            this.features = this.org.permissions.features
          })
        this.$nextTick(() => {
          this.form.validateFields()
        })
      })
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.user.meta = {
            ...this.user.meta,
            name: values.name,
          }
          this.user.permissions = {
            ...this.user.permissions,
            features: values.features,
            role: values.role,
          }

          axios
            .put(process.env.VUE_APP_KONSUL_API_URL + '/users', this.user, {
              headers: {
                Authorization: 'Bearer ' + this.$auth.user.access_token,
              },
            })
            .then(
              (res) => {
                this.$notification.success({
                  message: `${
                    res?.data?.meta?.name || 'User'
                  } Successfully Updated`,
                })
                this.$router.push({
                  name: 'user-management',
                })
              },
              () => {
                this.$notification.error({
                  message: 'Failed to Update User',
                })
              }
            )
        }
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div v-if="showUser" class="ant-row profile--container">
      <div class="breadcrumb--container">
        <a-breadcrumb>
          <a-breadcrumb-item href="#">
            <router-link to="/">
              <a-icon type="home" />
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="#">
            <router-link to="/user-management">
              <a-icon type="team" />
              <span>User Management</span>
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <a-icon type="profile" />
            User Profile
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="form-container">
        <div
          class="header"
          style="
            padding: 1.2rem;
            margin-bottom: 0;
            text-align: center;
            background: #141414;
            border-radius: 4px 4px 0 0;
          "
        >
          <h4 style="margin: 0; font-weight: 100; color: #fff">
            <a-icon type="profile" style="padding-right: 4px" />
            User Profile &middot; {{ this.$route.params.userId }}
          </h4>
        </div>

        <template v-if="user">
          <a-form :form="form" @submit="handleSubmit">
            <a-card>
              <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="User Meta Data">
                  <a-card style="width: 100%">
                    <a-row>
                      <a-col :sm="16" :md="12">
                        <a-form-item label="Name">
                          <a-input
                            v-decorator="[
                              'name',
                              {
                                initialValue: user.meta.name,
                                rules: [
                                  {
                                    required: true,
                                    placeholder: 'Please input your name!',
                                  },
                                ],
                              },
                            ]"
                            :placeholder="this.$route.params.userId"
                          />
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </a-card>
                </a-tab-pane>

                <a-tab-pane key="2" tab="User Permissions" force-render>
                  <a-row>
                    <div class="ant-col ant-col-8">
                      <a-card title="Role Type">
                        <a-form-item label="Select a User Role">
                          <a-select
                            v-decorator="[
                              'role',
                              {
                                initialValue: user.permissions.role,
                              },
                            ]"
                          >
                            <a-select-option value="admin">
                              Admin
                            </a-select-option>
                            <a-select-option value="user">
                              User
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-card>
                    </div>

                    <a-col :sm="16" :md="12">
                      <a-form-item label="Features">
                        <a-select
                          v-decorator="[
                            'features',
                            {
                              initialValue: user.permissions.features,
                            },
                          ]"
                          mode="multiple"
                        >
                          <a-select-option
                            v-for="(f, i) in features"
                            :key="i + f"
                            :value="f"
                          >
                            {{ f }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-tab-pane>
              </a-tabs>

              <a-row class="submit--container">
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button
                      type="primary"
                      html-type="submit"
                      :disabled="hasErrors(form.getFieldsError())"
                    >
                      Save
                    </a-button>
                  </a-form-item>
                </a-col>
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button @click="$router.go(-1)"> Cancel </a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-card>
          </a-form>
        </template>
        <template v-else>
          <div class="loader--container">
            <a-icon
              type="loading"
              style="padding-left: 4px; font-size: 24px; color: #1890ff"
              spin
            />
          </div>
        </template>
      </div>
    </div>
    <div v-else>
      <h1>403: Unauthorized</h1>
    </div>
  </Layout>
</template>
